/* @ngInject */
export default (LayoutService, $timeout) => {
	return {
		link: function (scope, element) {
			LayoutService.onUpdated(() => {
				let title = 'All About Caring';

				if (LayoutService.getTitle()) {
					if (angular.isArray(LayoutService.getTitle())) {
						title = LayoutService.getTitle()
						                     .join(' - ') + ' - All About Caring';
					} else {
						title = LayoutService.getTitle() + ' - All About Caring';
					}
				}

				$timeout(() => {
					element.text(title);
				});
			});
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/pageTitle.js